import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import AppBar from './components/appBar.js';
import Home from './components/home.js';
import AboutUs from './components/about.js';
import ContactUs from './components/contactUs.js';
import SysIntro from './components/sysIntro.js';
// import ApplicationForm from './components/applicationForm.js';

function HomePage() {
  return (
    <div>
      <Home />
      <SysIntro />
      <AboutUs />
      {/* Team section temporarily hidden
      <TeamSection />
      */}
      <ContactUs />
    </div>
  );
}

function App() {
  return (
    <Router>
      <div>
        <AppBar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* <Route path="/application-form" element={<ApplicationForm />} /> */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
